<template>
  <div class="bg-[#66A3FF14] text-white rounded-xl border border-[#FFFFFF1F] p-6">
    <!-- Header -->
    <div class="flex justify-between items-center mb-16">
      <h3 class="text-white text-lg font-medium">Price</h3>
      <span class="text-white text-lg">
        ${{ values[0] }} - ${{ values[1] }}
      </span>
    </div>

    <!-- Slider -->
    <div class="relative w-full mb-1">
      <Slider
        v-model="values"
        :min="min"
        :max="max"
        :step="step"
        range
        class="w-full"
        aria-label="slider"
      />

      <!-- Left (Min) Floating Box -->
      <div
        class="absolute -top-10 bg-slate-700 rounded-lg px-3 py-1 text-white text-sm font-medium transform -translate-x-1/2"
        :style="{ left: getPercentage(values[0]) + '%' }"
      >
        ${{ values[0] }}
      </div>

      <!-- Right (Max) Floating Box -->
      <div
        class="absolute -top-10 bg-slate-700 rounded-lg px-3 py-1 text-white text-sm font-medium transform -translate-x-1/2"
        :style="{ left: getPercentage(values[1]) + '%' }"
      >
        ${{ values[1] }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  min?: number;
  max?: number;
  step?: number;
  defaultValue?: [number, number];
}>();

const min = props.min ?? 0;
const max = props.max ?? 2000;
const step = props.step ?? 10;
const values = ref<[number, number]>(props.defaultValue ?? [80, 1130]);

/**
 * Prevent slider handles from crossing
 */
watch(values, (newVal, oldVal) => {
  if (newVal[0] > newVal[1]) {
    // revert to previous valid state
    values.value = [...oldVal];
  }
});

/**
 * Convert value -> percentage of slider track
 */
const getPercentage = (value: number) => {
  return ((value - min) / (max - min)) * 100;
};
</script>
